import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import {
  matchQuery,
  MutationCache,
  QueryCache,
  QueryClient,
  QueryKey
} from "@tanstack/react-query";
import { PersistQueryClientProviderProps } from "@tanstack/react-query-persist-client";

import localforage from "localforage";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000 // 10 minutes
    }
  },
  mutationCache: new MutationCache({
    onSuccess: (_data, _variables, _context, mutation) => {
      queryClient.invalidateQueries({
        predicate: (query) => {
          const mutationMeta =
            (mutation.meta?.invalidates as Array<QueryKey>) ?? [];
          return (
            mutationMeta?.some((queryKey: QueryKey) =>
              matchQuery({ queryKey }, query)
            ) ?? true
          );
        }
      });
    }
  }),
  queryCache: new QueryCache({
    onError: () => {} // Original error handler
  })
});

// Create async persister using official package
export const localForagePersister = createAsyncStoragePersister({
  storage: localforage,
  key: "react-query",
  throttleTime: 1000 // Throttle writes to reduce I/O operations
});

export const persistOptions: PersistQueryClientProviderProps["persistOptions"] =
  {
    persister: localForagePersister,
    maxAge: 24 * 60 * 60 * 1000,
    dehydrateOptions: {
      shouldDehydrateQuery: (query) => query.meta?.shouldPersist === true
    }
  };
